<script setup>
import PTooltip from '@/components/ProxifyUI/PTooltip.vue';

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  arrowPosition: {
    type: String,
    default: 'top',
    validator: (value) =>
      [
        'none',
        'bottom left',
        'bottom center',
        'bottom right',
        'top',
        'left',
        'right',
      ].includes(value),
  },
  maxWidth: String,
  offset: {
    type: Array,
    required: false,
    default() {
      return [0, 0];
    },
  },
  target: {
    type: [Boolean, String, Object],
    required: false,
    default() {
      return true;
    },
  },
  tooltipClass: {
    type: String,
    required: false,
    default: 'shadow-lg',
  },
});
</script>

<template>
  <PTooltip
    class="!rounded-lg py-[8px] px-[12px]"
    :class="{
      'arrow-bottom-left': arrowPosition === 'bottom left',
      'arrow-bottom-center': arrowPosition === 'bottom center',
      'arrow-bottom-right': arrowPosition === 'bottom right',
      'arrow-top': arrowPosition === 'top',
      'arrow-left': arrowPosition === 'left',
      'arrow-right': arrowPosition === 'right',
      [tooltipClass]: Boolean(tooltipClass),
    }"
    :offset="offset"
    :max-width="maxWidth"
    :target="target"
  >
    <div class="text-body-xs font-semibold text-proxify-gray-700">
      <slot />
    </div>
  </PTooltip>
</template>
